// Add "Verified buyer"
document.addEventListener("DOMContentLoaded", function () {
  //console.log("✅ DOMContentLoaded: verified buyer script loaded");

  // Sirf product page pe chale
  if (!document.body.classList.contains("template-product")) {
    //console.log("⛔ Not a product page, exiting script");
    return;
  }
  //console.log("✅ Product page detected");

  // ✅ Function jo encoding fix karega
  function fixEncoding(str) {
    if (!str) return "";
    return str
      .replace(/�/g, "'")                // replacement char → normal '
      .replace(/[\u2018\u2019]/g, "'")   // curly single quotes → '
      .replace(/[\u201C\u201D]/g, '"');  // curly double quotes → "
  }

  // Function
  function enhanceReviews(scope) {
    //console.log("🔍 enhanceReviews function triggered");

    let reviewUsers = scope.querySelectorAll(
      ".jdgm-rev-widg__reviews .jdgm-rev__author"
    );

    reviewUsers.forEach((el, index) => {
      //console.log(`➡️ Checking review user #${index + 1}`);

      if (!el.querySelector(".cust-verified-buyer")) {
        //console.log(`✅ Adding verified badge to review #${index + 1}`);

        el.insertAdjacentHTML(
          "beforeend",
          `
          <p class="cust-verified-buyer" style="display: flex; align-items: center; gap: 3px; line-height: 16px; color: #000; margin: 0;">
            <span>
              <img src="https://cdn.shopify.com/s/files/1/0755/3207/5224/files/verified.png?v=1756368104" 
                   alt="verifiedpurchase review" width="28" height="28">
            </span> Verified buyer
          </p>
        `
        );
      } else {
        //console.log(`⚠️ Verified badge already exists for review #${index + 1}`);
      }
    });
  }

  // Initial run
  setTimeout(function () {
    enhanceReviews(document);
  }, 1000);

  // Pagination click run
  document.addEventListener("click", function (e) {
    if (e.target && e.target.classList.contains("jdgm-paginate__page")) {
      //console.log("⏳ Pagination clicked, waiting for reviews to load...");
      setTimeout(function () {
        enhanceReviews(document);
        document.querySelectorAll(".jdgm-rev__body").forEach(el => {
          el.innerHTML = fixEncoding(el.innerHTML);
        });
      }, 500);
    }
  });
});


// Encoding charcters correction
// ✅ Function jo encoding fix karega
function fixEncoding(str) {
  if (!str) return "";
  return str
    .replace(/�/g, "'")                // replacement char → normal '
    .replace(/[\u2018\u2019]/g, "'")   // curly single quotes → '
    .replace(/[\u201C\u201D]/g, '"');  // curly double quotes → "
}

// ✅ Page load ke baad saare reviews ke text ko clean kar do
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".jdgm-rev__body").forEach(el => {
    el.innerHTML = fixEncoding(el.innerHTML);
  });
});
// Encoding charcters correction